export default __webpack_public_path__ + "static/media/ic-sv.d420431c.svg";